/**
 * v-auto-focus will focus elements just like html autofocus, but this one can focus element each time when it's mounted while html autofocus only work when first mounted.
 */
export default {
  mounted(el, binding) {
    if (binding.value) el.focus();
  },
};
